import * as React from "react";
import { Fade } from "../ui";
import { usePrefersReducedMotion } from "../../hooks/usePrefersReducedMotion";

export const FADE_IN_MS = 200;

// Opacity only: a transform would make this the containing block for the page's sticky headers.
export const FadeIn: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const still = usePrefersReducedMotion();
  return (
    <Fade visible appear durationMs={still ? 0 : FADE_IN_MS}>
      <div>{children}</div>
    </Fade>
  );
};
